<template lang="pug">
section
  s-page-title(title='Баннеры')
    template(slot='extension')
      s-sort-button(@click='sorting.opened = true' class='mr-3')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
        template(slot='controls')
          v-layout
            v-flex(xs12)
              s-region-picker(
                :value='dataFilter.region_id'
                :returnObject='false'
                @change='setRegionId'
                label='Выберите регион'
              )
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.sort_number }}
          td {{ props.item.name }}
          td {{ props.item.published_at }}
          td(data-label='Время действия' class='wrapless')
            div()
              span(v-if='props.item.start_time') c {{ props.item.start_time | date }} &nbsp;
              span(v-if='props.item.stop_time') по {{ props.item.stop_time | date }}
            v-chip(v-for="(region, index) in props.item.regions" :key="index" small) {{region}}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              resource='banners'
            )
  s-sorting-list(v-model='sorting' @sort-success='fetch')
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: true
      },
      {
        text: 'Порядок',
        align: 'left',
        value: 'sort_number',
        width: '0%',
        sortable: true
      },
      {
        text: 'Название',
        align: 'left',
        sortable: true,
        value: 'name'
      },
      {
        text: 'Дата публикации',
        align: 'left',
        value: 'published_at',
        width: '0%',
        sortable: true
      },
      {
        text: 'Время действия',
        align: 'left',
        width: '50%',
        sortable: false
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ],
    sorting: {
      opened: false,
      resource: 'banners',
      itemValue: 'id',
      itemText: 'name',
      renderFn(item) {
        if (item.name) return `<b>` + item.regions + `</b>:     ` +item.name
        return item.regions
      }
    }
  }),

  created() {
    this.setDataFilter({
      sortBy: 'sort_number',
      descending: false
    })
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    setRegionId(region_id = null) {
      this.setDataFilter({ region_id })
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Content.Banners.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: this.dataFilter
        }
      })
    },

    async onDelete({ id }) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await this.destroy({ id })
          this.fetch()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('content/banners', ['fetchList', 'destroy']),
    ...mapMutations('content/banners', ['setDataFilter'])
  },

  computed: {
    ...mapState('content/banners', ['total', 'dataFilter']),
    ...mapGetters('content/banners', ['list', 'isLoading']),
  }
}
</script>
